enum ClientType {
    PERSONAL = 1,
    COMPANY = 2,
}

export default ClientType;
